import { useFormik, FormikConfig, FormikContextType } from 'formik';
import * as Yup from 'yup';
import { PaymentPlanType } from '@acorn-portal/shared/src/services/api';
import { useFormikLogErrors } from '@acorn-portal/shared/src/pages/mta/components/FormikLogErrors';

export interface IMissingPaymentFormValues {
	email: string;
	proceed: boolean;
	vaultCardOptOut: boolean;
	splitPaymentPlanType?: PaymentPlanType;
}

type OnSubmitFunctionType = (values: IMissingPaymentFormValues) => void | Promise<void>;

const useMissingPaymentForm = (initialValues: IMissingPaymentFormValues, onSubmit: OnSubmitFunctionType) => {
	const validationSchema = Yup.object({
		email: Yup.string()
			.email('Please enter a valid email address.')
			.required('Please enter your email address to receive payment confirmation.'),
		proceed: Yup.boolean().oneOf([true], 'You must proceed to continue.'),
	});

	const formikConfig: FormikConfig<IMissingPaymentFormValues> = {
		initialValues,
		validationSchema,
		onSubmit,
	};

	const formik = useFormik<IMissingPaymentFormValues>(formikConfig);

	useFormikLogErrors(formik as FormikContextType<unknown>);

	return formik;
};

export default useMissingPaymentForm;
